import Btn from '@componentPrimitives/Btn';
import Flex from '@componentPrimitives/Flex';
import Txt from '@componentPrimitives/Txt';
import Card from '@components/Card';
import { useEvent, useIsRTC } from '@lib/hooks';
import { useTranslations } from 'next-intl';
import { EntryCardProps } from './EntryCard';

export type EventTicketedCardProps = EntryCardProps<'event'>;

export const EventTicketedCard = ({ item, ...props }: EventTicketedCardProps) => {
  const t = useTranslations('cta');
  const {
    eventDateFormatted,
    uri: href,
    title,
    entrySummary: description,
    entryImage: image,
    eventPrice,
    eventPricePrefix,
    buyTicketsLink,
  } = useEvent(item);

  // console.log(useEvent(item), item);

  const eventMeta: string[] = [];

  if (eventDateFormatted) eventMeta.push(eventDateFormatted);

  const isRtc = useIsRTC();

  return (
    <Card
      {...props}
      fullHeight
      item={{
        title,
        description,
        image,
      }}>
      <Card.Image ratio="landscape" transform="landscapeSmCrop" />
      <Card.Body cx={{ pX: 'xs', pT: 'md' }}>
        {isRtc ? (
          // The RTC version
          <>
            <Card.Title variant="h6" cx={{ mB: '3xs' }} />
            <Card.Description
              maxChars={100}
              cx={{
                mY: '3xs',
              }}
            />
          </>
        ) : (
          // The default version
          <>
            <Card.Title variant="h6" cx={{ mB: '3xs' }} />
            <Card.Meta cx={{ mT: '3xs' }} />
            <Card.Description maxChars={100} cx={{ mY: 'xs' }} />
          </>
        )}
      </Card.Body>
      <Card.Foot cx={{ pX: 'xs', pB: 'xs' }}>
        <Flex>
          <Txt variant="bodyAlt" color="secondaryContrast" cx={{ mB: 'none' }}>
            {eventPricePrefix}
          </Txt>
          <Txt variant="h3" color="secondaryContrast" cx={{ mB: 'sm' }}>
            {eventPrice}
          </Txt>
          <Btn {...buyTicketsLink} fullWidth variant="filled" color="primary" cx={{ mB: 'xs' }} />
          {href && (
            <Btn variant="text" href={href} underline="none" size="small">
              {t('discover')}
            </Btn>
          )}
        </Flex>
      </Card.Foot>
    </Card>
  );
};
